import React from "react";

import "./supportDescriptionView.m.css";

const SupportDescriptionView = () => {
  const content1 = {
    title: "Pioneers & Gamechangers:",
    list: [
      "Get a premium, ad-free experience of The Quint, Quint Hindi, and FIT",
      "Stay updated with a daily newsletter curated with important stories on The Quint, Quint Hindi, and FIT",
      "Quick news updates with access to our exclusive Telegram group",
      "Get invited to our members-only events and webinars",
      "Join the conversation on our exclusive members-only Facebook group",
      "Enjoy early access to our premium content, and a behind-the-scenes look at what goes into doing a story",
      "Stay Informed with our weekly WebQoof round-up, important fact-checked stories delivered to your inbox.",
    ],
  };

  const content2 = {
    title: "Leaders & Ambassadors:",
    list: [
      "Get every privilege offered to the Pioneers and Gamechangers +",
      "Be a part of the webinars with senior journalists from The Quint, Quint Hindi, and FIT.",
      "Get your opinion piece or article published on The Quint’s exclusive Members’ Opinion section, every month.",
      "Catch a glimpse of everything that goes into making a ground report: Behind the Story, with our journalists",
    ],
  };

  const getView = (data) => (
    <div styleName="content" className="container">
      <div styleName="title">{data.title}</div>

      <ul styleName="list-items">
        {data.list.map((value, index) => (
          <li key={index}>{value}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <div styleName="wrapper">
      {getView(content1)}
      {getView(content2)}
    </div>
  );
};

export default SupportDescriptionView;
